function copyToClipboard(){
    const btn = document.querySelector('[data-copy-to-clipboard]');
    if (btn) {
        btn.addEventListener('click', () => {
            let textBox = document.getElementById("affiliate-link"),
                copiedText = document.querySelector('.recommend-page__affiliate-copied');

            if (copiedText) {
                copiedText.classList.remove('d-none');
            }
            
            textBox.select();
            document.execCommand("copy");
        });
    }
}

export default {copyToClipboard};



// WEBPACK FOOTER //
// ./src/scripts/copy-to-clipboard.js